import RichText from '@eneco/components/RichText/RichText';
import { OrderStatusCardResponse } from '@eneco/dc-be/client/types.gen.js';
import { useFormatter } from '@eneco/i18n';
import { Box, Heading, Stack, Text } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { EnergyIcon } from '../../advance/components/EnergyIcon';

export const OrderStatusCard = ({ card }: { card: OrderStatusCardResponse }) => {
  const { details } = card;
  const { fields } = useContent<DashboardOverviewRendering>();
  const { format, address } = useFormatter();

  const formattedAddress = address.medium({
    street: details.address.street,
    houseNumber: details.address.houseNumber,
    houseNumberSuffix: details.address.bus,
    postalCode: details.address.postalCode,
    city: details.address.municipality,
  });

  const description = format(fields.orderStatusCard?.description?.value || '', {
    deliveryAddress: formattedAddress,
  });

  return (
    <StyledDashboardBlock>
      <RichText html={description} />
      <Stack gap={4}>
        <Heading size="3XS" as="h3">
          {fields.orderStatusCard?.productsTitle?.value}
        </Heading>
        <Stack gap={2}>
          {details.gasEan && (
            <Box padding={4} backgroundColor="backgroundSecondary" borderRadius="s">
              <Stack direction="row" alignY="center" gap={4}>
                <Stack.Item shrink={false}>
                  <Box paddingY={2} paddingX={5} backgroundColor="backgroundPrimary" borderRadius="s">
                    <EnergyIcon energyType="Gas" size="medium" />
                  </Box>
                </Stack.Item>
                <Stack>
                  <Text weight="bold" size="BodyS">
                    {fields.orderStatusCard?.gasLabel?.value}
                  </Text>
                  <Text>{details.gasEan}</Text>
                </Stack>
              </Stack>
            </Box>
          )}
          {details.electricityEan && (
            <Box padding={4} backgroundColor="backgroundSecondary" borderRadius="s">
              <Stack direction="row" alignY="center" gap={4}>
                <Stack.Item shrink={false}>
                  <Box paddingY={2} paddingX={5} backgroundColor="backgroundPrimary" borderRadius="s">
                    <EnergyIcon energyType="Electricity" size="medium" />
                  </Box>
                </Stack.Item>
                <Stack>
                  <Text weight="bold" size="BodyS">
                    {fields.orderStatusCard?.electricityLabel?.value}
                  </Text>
                  <Text>{details.electricityEan}</Text>
                </Stack>
              </Stack>
            </Box>
          )}
        </Stack>
      </Stack>
    </StyledDashboardBlock>
  );
};
